"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Articles = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = require("@cx/couturier/Grid");

var _RightForward = _interopRequireDefault(require("@cx/couturier/icons/utils/RightForward"));

var _Carousel = _interopRequireDefault(require("../Carousel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIZE = 3;

var toArticleGroups = function toArticleGroups(articles) {
  return articles.reduce(function (groups, val, idx) {
    if (idx % SIZE === 0) groups.push([]);
    groups[groups.length - 1].push(val);
    return groups;
  }, []);
};

var VideoIcon = function VideoIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "video-icon",
    width: "34px",
    height: "24px",
    viewBox: "0 0 34 24"
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: "Investments",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: "Investmenst_Desktop_Retirement",
    transform: "translate(-885.000000, -1662.000000)",
    stroke: "#FFFFFF",
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: "Insights-on-investing",
    transform: "translate(0.000000, 1323.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: "Storyblock_Card_Image",
    transform: "translate(40.000000, 151.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: "Video-Icon",
    transform: "translate(845.000000, 188.000000)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    className: "Rectangle-3",
    x: "0.75",
    y: "0.75",
    width: "32.5",
    height: "22.5",
    rx: "2"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    className: "Triangle-2",
    fill: "#FFFFFF",
    transform: "translate(17.000000, 12.000000) rotate(90.000000) translate(-17.000000, -12.000000) ",
    points: "17 7 22 17 12 17"
  })))))));
};

var Article = function Article(_ref) {
  var article = _ref.article,
      idx = _ref.idx,
      _onClick = _ref.onClick,
      _onMouseOver = _ref.onMouseOver;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "article article-".concat(idx),
    tabindex: "-1",
    href: article.url,
    target: "_new",
    onClick: function onClick(ev) {
      return _onClick && _onClick(ev, article, idx);
    },
    onMouseOver: function onMouseOver(ev) {
      return _onMouseOver && _onMouseOver(ev, article, idx);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "image-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "article-image",
    src: article.thumbnail,
    alt: article.altText ? article.altText : ''
  }), article.hasVideo && /*#__PURE__*/_react.default.createElement(VideoIcon, null)), /*#__PURE__*/_react.default.createElement("h3", {
    className: "article-headline"
  }, article.headline), /*#__PURE__*/_react.default.createElement("div", {
    className: "read-more"
  }, "Read More ", /*#__PURE__*/_react.default.createElement(_RightForward.default, null)));
};

var Articles = function Articles(_ref2) {
  var className = _ref2.className,
      articles = _ref2.articles,
      onSceneChange = _ref2.onSceneChange,
      onClick = _ref2.onClick,
      onMouseOver = _ref2.onMouseOver;
  var groups = toArticleGroups(articles);
  return /*#__PURE__*/_react.default.createElement(_Grid.Col, {
    small: 12,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    className: "carousel-desktop",
    afterChange: function afterChange(idx, slide) {
      if (onSceneChange) {
        onSceneChange(idx);
      }
    }
  }, groups.map(function (group, groupIdx) {
    return /*#__PURE__*/_react.default.createElement(_Grid.Row, {
      className: "article-group article-group-".concat(groupIdx),
      key: groupIdx
    }, group.map(function (article, idx) {
      return /*#__PURE__*/_react.default.createElement(_Grid.Col, {
        small: 12,
        medium: 4,
        key: idx
      }, /*#__PURE__*/_react.default.createElement(Article, {
        article: article,
        idx: idx,
        onClick: onClick,
        onMouseOver: onMouseOver
      }));
    }));
  })), /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    className: "carousel-mobile",
    afterChange: function afterChange(idx, slide) {
      if (onSceneChange) {
        onSceneChange(idx);
      }
    }
  }, groups[0] && groups[0].map(function (article, idx) {
    return /*#__PURE__*/_react.default.createElement(Article, {
      key: idx,
      article: article,
      idx: idx,
      onClick: onClick,
      onMouseOver: onMouseOver
    });
  })));
};

exports.Articles = Articles;
Articles.propTypes = {
  articles: _propTypes.default.array.isRequired,
  onSceneChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onMouseOver: _propTypes.default.func,
  className: _propTypes.default.string
};